import React, { useContext, useEffect, useState } from "react";
import CustomFolderList from "../../Components/CustomFolderList";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../../Network/apiCallGateway";
import { DataContext } from "../../context/DataContext";
import GridView from "../../Components/GridView";
import { addFolderschema } from "../../Validation/FolderValidation";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import NoData from "../../Components/NoData";
import Pagination from "../../Components/Pagination/Pagination";

function SharedEnvs(props) {
  const history = useHistory();
  const { adminViewUser, setBrudCrumb, setSidebarSelected } =
    useContext(DataContext);

  const [shareEnvPage, setshareEnvPage] = useState(1);
  const [addFolderModal, setAddFolderModal] = useState(false);
  const [envDetails, setEnvdetails] = useState({});
  const [envEdit, setEnvEdit] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [envId, setEnvId] = useState("");

  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);

  const {
    isLoading: envLoading,
    data: envList,
    refetch,
  } = useQuery({
    queryKey: ["shareEnvList"],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAllShareEnvs(
        shareEnvPage,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });

  useEffect(() => {
    refetch();
    setSidebarSelected("shared");
  }, [shareEnvPage, adminViewUser]);

  const folderFormik = useFormik({
    initialValues: {
      name: envEdit ? envDetails?.name : "",
      description: envEdit ? envDetails?.description : "",
    },
    validationSchema: addFolderschema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      // console.log(values);
      let res;
      if (envEdit) {
        res = await ApiCallGateway.folder.updateFolderEnv(
          values,
          envDetails?.envId
        );
      }
      refetch();
      // console.log(res);
    },
  });
  return (
    <div>
      {props?.viewType === "list" ? (
        <CustomFolderList
          env_subfolder={true}
          data={envList?.data}
          onItem={(fdetails) => {
            // console.log(fdetails);
            history.push(`/env_passwords/${fdetails?.envId}`);
            // setEnvDetails(fdetails);
          }}
          confirmtoggle={(id) => {
            confirmtoggle();
            setEnvId(id);
          }}
          edittoggle={(details) => {
            // console.log(details);
            setEnvdetails(details);
            setEnvEdit(true);
            addFoldertoggle();
          }}
          hideMore={true}
        />
      ) : null}

      {props?.viewType === "grid" ? (
        <GridView
          env_subfolder={true}
          data={envList?.data}
          onItem={(fdetails) => {
            history.push(`/env_passwords/${fdetails?.envId}`);
          }}
        />
      ) : null}

      {envList?.data?.length < 1 ? <NoData /> : null}
      <Pagination
        totalPost={envList?.total}
        postsPerPage={12}
        setCurrentPage={(e) => setshareEnvPage(e)}
        currentPage={shareEnvPage}
      />
    </div>
  );
}

export default SharedEnvs;
